import React from 'react'
import PropTypes from 'prop-types'
import AccessedItemImage from './AccessedItemImage'
import './AccessedItemsRow.scss'

const AccessedItemRow = props => {
  let productAuthors
  if (props.item.type === 'playlist') {
    productAuthors = (
      <a href={`users/${props.item.authors.slug}`}>{props.item.authors.name}</a>
    )
  } else {
    productAuthors = props.item.authors.map((coach, idx) => {
      let coachName = `${coach.firstName} ${coach.lastName}`
      if (
        props.item.authors.length > 1 &&
        idx === props.item.authors.length - 1
      ) {
        coachName = ' & '.concat(coachName)
      }
      if (
        props.item.authors.length > 0 &&
        idx < props.item.authors.length - 2
      ) {
        coachName += ', '
      }
      return (
        <span key={coach.slug}>
          <a href={'/instructors/' + coach.slug}>{coachName}</a>
        </span>
      )
    })
  }

  const goToItem = () => {
    window.location.href = props.item.link
  }

  return (
    <div onClick={goToItem} className='AccessedItemRow'>
      <div className='AccessedItemRow__accessedItemContainer'>
        <div className='AccessedItemRow__itemImageContainer'>
          <div className='AccessedItemRow__itemImage'>
            <AccessedItemImage item={props.item} includeMetaInfo={false} />
          </div>
        </div>
        <div className='AccessedItemRow__itemInfo'>
          <div className='AccessedItemRow__title'>{props.item.title}</div>
          <div className='AccessedItemRow__meta'>
            <span className='AccessedItemRow__type'>{props.item.type} </span>
            by{' '}
            <span className='AccessedItemRow__author'> {productAuthors}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

AccessedItemRow.propTypes = {
  item: PropTypes.object
}

export default AccessedItemRow
